import { gql } from '@apollo/client';

/**
 * Copy of History-v2's `SEARCH_ORDERS_QUERY`, trimmed to only what
 * `ReceiptPrinter` needs to resolve a local (unsynced) order into a real
 * backend order id: `items { id }` to match the local cart items against the
 * synced order's items, plus `easyId`/`createdAt` for the search filters.
 */
export const SEARCH_ORDERS_FOR_EMAIL_QUERY = gql`
  query AdvancedSearchOrdersForEmail($input: AdvancedSearchOrdersInput!) {
    operativeViewer {
      advancedSearchOrders(input: $input) {
        message
        orders {
          id
          easyId
          createdAt
          payment {
            id
            transactionId
          }
          items {
            id
          }
        }
        success
      }
    }
  }
`;
